import { render, staticRenderFns } from "./ShowDiplomModalComponent.vue?vue&type=template&id=2aa57084&scoped=true&"
import script from "./ShowDiplomModalComponent.vue?vue&type=script&lang=js&"
export * from "./ShowDiplomModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa57084",
  null
  
)

export default component.exports